import Swiper from 'swiper';
import Masonry from 'masonry-layout';
import Plyr from 'plyr/dist/plyr.polyfilled.js';
//import './navigation'; //Not working. Is it even used?
import './macy';
import './modal';
import Parsley from 'parsleyjs/dist/parsley.js';
import './annual-animations';
import './annual';
import './annual-fy20';
import './together';
import './back-buttons';
import './charts';
import './investment-form';
import './plyr';
import './tracking';
import './filter';
import './primaryNavDropdown';

import '../scss/style.scss';

$(function () {
  /* Sub nav */
  if ($('.js-scroll-container').length) {
    let scrollContainer = $('.js-scroll-container')[0];
    if (scrollContainer.scrollWidth > scrollContainer.getBoundingClientRect().width) {
      scrollContainer.classList.add('scrollable');
      document.getElementById('js-scroll-icon').style.display = 'block';
    }
  }

  if ($('#player').length) {

    const player = new Plyr('#player', {
      controls: ['volume', 'fullscreen', 'play'],
      hideControls: false,
      youtube: { noCookie: true },
      vimeo: { dnt: true }
    })
    player.toggleControls(false)
    const mobilePlayer = new Plyr('#mobilePlayer', {
      controls: ['volume', 'fullscreen', 'play'],
      youtube: { noCookie: true },
      vimeo: { dnt: true }
    })
    player.on('pause', event => {
      $('.player-title').fadeIn(180)
      $('.video-hero-overlay').fadeIn(180)
      $('.video-bottom-overlay').fadeIn(180)
      $('.sub-page-links').fadeIn(180)
      $('.mobile-video-popup').removeClass('visible');
      player.toggleControls(false)
    });
    player.on('play', event => {
      $('.player-title').fadeOut(180)
      $('.video-hero-overlay').fadeOut(180)
      $('.video-bottom-overlay').fadeOut(180)
      $('.sub-page-links').fadeOut(180)
      player.toggleControls(true)
    })
    mobilePlayer.on('pause', event => {
      $('.player-title').fadeIn(180)
      $('.video-hero-overlay').fadeIn(180)
      $('.video-bottom-overlay').fadeIn(180)
      $('.sub-page-links').fadeIn(180)
      $('.mobile-video-popup').removeClass('visible');
    });
    mobilePlayer.on('play', event => {
      $('.player-title').fadeOut(180)
      $('.video-hero-overlay').fadeOut(180)
      $('.video-bottom-overlay').fadeOut(180)
      $('.sub-page-links').fadeOut(180)
    })
    $('.js-play-plyr').click(function () {
      player.play()
    })
    $('.js-mobile-plyr').click(function () {
      $('.mobile-video-popup').addClass('visible');
      mobilePlayer.play()
    })
  }

  const bigPlayers = Plyr.setup('.js-big-player', {
    youtube: { noCookie: true },
    vimeo: { dnt: true }
  });

  let videoLinks = document.querySelectorAll('.js-video-link');
  let linkPlayerPopup = document.getElementById('js-video-popup');
  let videoBg = document.querySelector('.video-bg');
  let p = null;;

  if (videoLinks.length > 0) {

    videoLinks.forEach(link => {

      link.addEventListener('click', function (e) {
        let linkPlayer = document.getElementById('js-video-link-player');
        e.stopPropagation();
        e.preventDefault();

        if (bigPlayers) {
          bigPlayers.forEach(bigP => {
            bigP.stop();
          });
        }

        let videoProvider = this.getAttribute('data-video-provider');
        let videoId = this.getAttribute('data-video-embed-id');
        linkPlayer.setAttribute('data-plyr-provider', videoProvider);
        linkPlayer.setAttribute('data-plyr-embed-id', videoId);


        p = new Plyr(linkPlayer, {
          youtube: { noCookie: true },
          vimeo: { dnt: true }
        });

        p.on('ready', event => {
          linkPlayerPopup.classList.add('active');
          document.body.style.overflow = 'hidden';
          p.play();
        });

        p.on('ended', event => {
          closeActiveVideo()
        });

        videoBg.classList.add('active');
        document.body.style.overflow = 'hidden';

      });

    });

    const closeActiveVideo = function () {
      videoBg.classList.remove('active');
      document.body.style.overflow = 'auto';
      p.destroy();
      linkPlayerPopup.classList.remove('active');
    }

    document.querySelectorAll('.close-video-popup')
      .forEach(el => el.addEventListener('click', closeActiveVideo))
  }
  /* End plyr */

  const hash = window.location.hash;
  if (hash) {
    if (hash.startsWith('#openvideo')) {
      const videoId = hash.split('#openvideo-')[1];
      const $videoLinkEl = $('.js-video-link[data-video-embed-id=' + videoId + ']');
      if ($videoLinkEl.length > 0) {
        $videoLinkEl[0].click();

        //If inside a filter, open that filter contents
        const $filterWrapper = $videoLinkEl.closest('.cards-filter');
        if ($filterWrapper.length > 0) {
          //Get name of current video's filter selection
          const filterName = $videoLinkEl.closest('.filter-content').data('filter');
          if (filterName) {
            //Trigger click on the filter button for the current opened video's filter
            $('.filter-button[data-filter="' + filterName + '"]').trigger('click');
          }
        }
      }
    }
  }

  const sliders = document.querySelectorAll('.js-swiper');

  /* console.log(sliders); */

  sliders.forEach(item => {
    let spaceBetween = item.dataset.spaceBetween;
    spaceBetween = spaceBetween !== undefined ? parseInt(spaceBetween) : spaceBetween;
    const slidesPerView = item.dataset.slidesPerView !== undefined ? parseInt(item.dataset.slidesPerView) : 'auto';
    const breakpoints = item.dataset.breakpoints !== undefined ? JSON.parse(item.dataset.breakpoints) : {};
    var cardSwiper = new Swiper(item, {
      direction: 'horizontal',
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
        draggable: true,
      },
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      preloadImages: false,
      lazy: true,
      watchSlidesVisibility: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints
    });
  });

  // Map click-functions
  $('.js-switch-pins').on('click', function () {

    $('.js-switch-pins').removeClass('active');
    $(this).addClass('active');

    $('.js-pin-holder').removeClass('active');
    $('.js-pin-holder').removeClass('active-info');

    $('.js-byline').removeClass('active');
    $('.js-key-facts-wrapper').removeClass('active');

    let data_type = $(this).data('type');

    // Had to use timeout, remove class didn't seem to work with callbacks
    setTimeout(function () {
      $('.js-pin-holder[data-parent="' + data_type + '"]').addClass('active');
      $('.js-byline[data-parent="' + data_type + '"]').addClass('active');
      $('.js-key-facts-wrapper[data-type="' + data_type + '"]').addClass('active');
      switch_key_facts($('.js-key-facts-wrapper[data-type="' + data_type + '"]'));
    }, 200);

  });

  $('.js-pin-holder').on('click', function () {

    if ($(this).hasClass('active-info')) {
      $('.js-pin-holder').removeClass('active-info');
      $(this).removeClass('active-info');
    }
    else {
      $(this).addClass('active-info');
      $(this).siblings().removeClass('active-info');
    }

  });

  $(document).on('click', function (e) {
    if (!$(e.target).hasClass('pin')) {
      $('.js-pin-holder').removeClass('active-info');
    }
  });

  function switch_key_facts(el) {
    let parent = $('.js-key-facts-wrapper.active')
    let next_sibling = $(parent).children('.js-key-facts-item.active').next('.js-key-facts-item');
    $('.js-key-facts-item.active').fadeOut(200, function () {
      $('.js-key-facts-item.active').removeClass('active');

      if ($(next_sibling).length > 0) {
        $(next_sibling).fadeIn();
        $(next_sibling).addClass('active');
      }
      else {
        let first_sibling = $(parent).children('.js-key-facts-item').first();
        $(first_sibling).fadeIn();
        $(first_sibling).addClass('active');
      }
    });
  }

  function auto_switch_key_facts() {
    switch_key_facts();
    setTimeout(auto_switch_key_facts, 5000);
  }
  setTimeout(auto_switch_key_facts, 6000);

  var masonic_wrappers = document.querySelectorAll('.masonic-wrapper');

  if (masonic_wrappers != null) {

    $.each(masonic_wrappers, function (index) {

      const masonryOptions = {
        itemSelector: '.masonic-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
      };

      new Masonry(masonic_wrappers[index], masonryOptions);
    });

  }

  // Search bar stuff, this could perhaps be better, like using just one icon to toggle

  $('.js-activate-search').on('click', function () {
    $('.search-holder').addClass('active');
    $('.search-input').focus();
    $('body').addClass('search-open');
  });

  $('.js-close-search').on('click', function () {
    $('.search-holder').removeClass('active');
    $('.search-input').val('');
    $('.search-input').blur();
    $('body').removeClass('search-open');
  });

  // Category selector for projects

  $('.js-project-category-selector').on('change', function () {

    $('.js-project-item').css('display', 'none');
    if (this.value == 'all') {
      $('.js-project-item').fadeIn();

    }
    else {
      $('.js-project-item').css('display', 'none');
      $('.js-project-item[data-term-id="' + this.value + '"]').fadeIn();
    }

  });



  // Add class "first" to content with page-spacing class present if hero is present
  try {
    var hero_container = $('.hero-container');
    if (hero_container) {
      var first_content_with_spacing = $('.page-spacing').first();
      if (first_content_with_spacing) {
        $(first_content_with_spacing).addClass('first-spaced-content-after-hero');
      }
    }
  } catch (error) { }

  $('.fb-share').click(function (e) {
    e.preventDefault();
    window.open($(this).attr('href'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    return false;
  });

  // FAQ
  $('.faq-item').on('click', function () {

    if ($(this).hasClass('active')) {

      $(this).removeClass('active');

    } else {

      $('.faq-item').each(function (index) {
        $(this).removeClass('active');
      });
      $(this).addClass('active');

    }
  });

  // Category dropdown
  $('#category-dropdown-btn').on('click', function () {
    if ($('#category-dropdown').hasClass('active')) {
      $('#category-dropdown').removeClass('active');
      $(this).removeClass('active');
    } else {
      $('#category-dropdown').addClass('active');
      $(this).addClass('active');
    }
  });

  // Menu on scroll
  $(window).bind('scroll', function () {

    var scrollTop = $(window).scrollTop();

    if (scrollTop > 200) {
      $('.menu-holder').addClass('on-scroll');
    } else {
      $('.menu-holder').removeClass('on-scroll');
    }
  });

  /* AR submenu 2022 */
  var scrollTop = $(window).scrollTop();
  var scrollPos = 0;
  var narrowSubMenu = false;
  var submenuOffset;
  var distance;
  if ($('#ar-22-submenu').length) {
    var submenuOffset = $('#ar-22-submenu').offset().top;
    var distance = (submenuOffset - scrollTop);

    if (distance < 1) {
      setNarrowSubmenu();
    }

    window.addEventListener('scroll', function () {
      scrollTop = $(window).scrollTop();

      if ((document.body.getBoundingClientRect()).top > scrollPos) {
        // scroll up

        getOffset();

        if (scrollTop > 200) {
          $('#ar-22-submenu').addClass('b-nav');
        }

        if (scrollTop < 201) {
          $('#ar-22-submenu').removeClass('b-nav');
          resetNarrowSubmenu();
        }

        if (distance > 70) {
          resetNarrowSubmenu();
        }

      } else {
        // scroll down

        $('#ar-22-submenu').removeClass('b-nav');

        getOffset();

        if (distance < 1) {
          if (narrowSubMenu == false) {
            setNarrowSubmenu();
          }
        }

      }

      scrollPos = (document.body.getBoundingClientRect()).top;
    });

  }

  function getOffset() {
    submenuOffset = $('#ar-22-submenu').offset().top;
    distance = (submenuOffset - scrollTop);
  }

  function setNarrowSubmenu() {
    $('#ar-22-submenu').addClass('narrow');
    narrowSubMenu = true;
  }

  function resetNarrowSubmenu() {
    if (narrowSubMenu == true) {
      $('#ar-22-submenu').removeClass('narrow');
      narrowSubMenu = false;
    }
  }




  /* AR submenu 2023 */
  const ar23Submenu = document.querySelector('#ar-23-submenu');

  if (ar23Submenu) {
    const hero = document.querySelector('.hero');
    const introWithGridCards = document.querySelector('.intro_with_grid_cards');
    const hero5050 = document.querySelector('.hero_5050');
    let target = null;

    if (hero5050) {
      target = hero5050;
    } else if (hero.nextElementSibling.nextElementSibling == introWithGridCards) {
      target = introWithGridCards;
    } else {
      target = hero;
    }

    function handleVisibility(entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          ar23Submenu.classList.add('active');
          setTimeout(function () {
            ar23Submenu.classList.add('visible');
          }, 200);
        } else {
          ar23Submenu.classList.remove('visible');
          setTimeout(function () {
            ar23Submenu.classList.remove('active');
          }, 200);
        }
      });
    }

    const observer = new IntersectionObserver(handleVisibility);
    observer.observe(target);
  }





  /* Scroll to top */
  var toPageTop = $('.js-to-page-top');

  if (toPageTop) {

    $(window).bind('scroll', function () {

      var scrollTop = $(window).scrollTop();

      if (scrollTop > 500) {
        toPageTop.addClass('active');
      } else {
        toPageTop.removeClass('active');
      }
    });

    toPageTop.on('click', function (e) {
      e.stopPropagation();

      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
    });
  }


  /* Read more articles */
  var $open = false;
  $('.read-more-btn').on('click', function () {

    var $textHolder = $(this).parents('.text-content').first();

    if ($open == false) {
      $open = true;
      $textHolder.addClass('current-article');
    } else if (($open == true) && $textHolder.hasClass('current-article')) {
      $open = false;
      $textHolder.removeClass('current-article');
    } else {
      $open = true;
      $('.full_text_image_block .current-article').removeClass('current-article');
      setTimeout(function () {
        $textHolder.addClass('current-article');
      }, 1000);
    }
  });

  /* Fact box read more */
  var $active = false;
  $('.read-more-fb').on('click', function (e) {
    e.preventDefault();

    var $content = $(this).parents('.extra-content');

    if ($active == false) {
      $active = true;
      $('.extra-content').each(function () {
        $(this).removeClass('active');
      });
      $content.addClass('active');
    } else {
      $active = false;
      $content.removeClass('active');
    }
  });
});


$(function () {

  /**
   * Check if a swiper has slides outside of viewport
   * @param swiper Swiper instance
   * @returns {boolean}
   */
  const sliderHasSlidesOutsideOfViewport = function (swiper) {
    return swiper.isBeginning === false || swiper.isEnd === false;
  }

  /**
   * Disable/enable swiper navigation
   * @param swiper Swiper instance
   * @param disable Boolean
   */
  const sliderDisableNavigation = function (swiper, disable) {
    const className = 'disable-navigation'
    swiper.allowSlideNext = !disable
    swiper.allowSlidePrev = !disable

    if (disable === true) {
      swiper.el.classList.add(className)
    } else {
      swiper.el.classList.remove(className)
    }
  }

  var newsTicker = new Swiper('.swiper-container-news-ticker', {
    direction: 'horizontal',
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: true
    },
    slidesPerView: 'auto',
    spaceBetween: 24,
    freeMode: true,
    preloadImages: false,
    lazy: true,
    watchSlidesVisibility: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  })

  var cardSwiper = new Swiper('.swiper-container-cards', {
    direction: 'horizontal',
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    slidesPerView: 'auto',
    spaceBetween: 24,
    preloadImages: false,
    lazy: true,
    watchSlidesVisibility: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  var carousel = new Swiper('.swiper-container-carousel', {
    direction: 'horizontal',
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    },
    slidesPerView: 'auto',
    spaceBetween: 24,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        if (false === sliderHasSlidesOutsideOfViewport(this)) {
          // No slides are outside of viewport
          // Disable slider navigation
          sliderDisableNavigation(this, true)
        }
      },
      resize: function () {
        if (false === sliderHasSlidesOutsideOfViewport(this)) {
          // No slides are outside of viewport
          // Disable slider navigation
          sliderDisableNavigation(this, true)
        } else {
          // We have slides outside of viewport
          // Enable slider navigation
          sliderDisableNavigation(this, false)
        }
      }
    },
  });

  var imgSwiper = new Swiper('.swiper-container-img', {
    direction: 'horizontal',
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
    }
  });

  /* On AR FY19 and video section */
  var smallSwiper = new Swiper('.swiper-container-small', {
    direction: 'horizontal',
    width: 274,
    spaceBetween: 16,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  var videoSwiper = new Swiper('.swiper-container-video', {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 24,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
    }
  });

  const cardGridComponent = {
    breakpoint: window.matchMedia('(max-width:767px)'),
    swipers: [],
    masonryGrids: [],
    init: () => {
      window.addEventListener('resize', cardGridComponent.breakpointChecker);
      cardGridComponent.breakpointChecker();
    },
    loadMore: (cardGrid, masonry) => {
      let items = Array.from(cardGrid.querySelectorAll('.load-more-bucket > div'));
      console.log(items);
      if (items.length) {
        if (items.length <= 3) {
          cardGrid.querySelector('.card_grid__load-more').remove()
        }
        items.slice(0, 3).forEach(item => {
          item.remove();
          cardGrid.querySelector('.swiper-wrapper').append(item);
          masonry.appended(item);
        });
      }
    },
    breakpointChecker: () => {
      // if larger viewport and multi-row layout needed
      if (cardGridComponent.breakpoint.matches === true) {
        if (cardGridComponent.masonryGrids) {
          cardGridComponent.masonryGrids.forEach(masonry => {
            masonry.destroy();
          });
          cardGridComponent.masonryGrids = [];
        }

        return cardGridComponent.enableSwiper();

      } else if (cardGridComponent.breakpoint.matches === false) {
        if (cardGridComponent.swipers.length) {
          cardGridComponent.swipers.forEach(swiper => {
            swiper.destroy(true, true);
          });
          cardGridComponent.swipers = [];
        }

        if (!cardGridComponent.masonryGrids.length) {
          var masonic_wrappers = document.querySelectorAll('.card_grid__swiper-container.card_grid__masonry .swiper-wrapper');

          masonic_wrappers.forEach(masonic_wrapper => {
            let masonry = new Masonry(masonic_wrapper, {
              itemSelector: '.swiper-slide',
              columnWidth: '.grid-sizer',
              percentPosition: true
            });
            let cardGrid = masonic_wrapper.closest('.card_grid');
            cardGrid.querySelectorAll('.load-more').forEach(loadMoreButton => {
              loadMoreButton.addEventListener('click', () => cardGridComponent.loadMore(cardGrid, masonry));
            });
            cardGridComponent.masonryGrids.push(masonry);
          });
        }
      }
    },
    enableSwiper: () => {
      document.querySelectorAll('.card_grid__swiper-container').forEach(swiper => {
        cardGridComponent.swipers.push(new Swiper(swiper, {
          direction: 'horizontal',
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
          },
          slidesPerView: 1,
          spaceBetween: 24,
          preloadImages: false,
          lazy: true,
          watchSlidesVisibility: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          }
        }));
      });
    }
  }

  cardGridComponent.init();

  const introWithGridCardsComponent = {
    breakpoint: window.matchMedia('(max-width:767px)'),
    swipers: [],
    init: () => {
      window.addEventListener('resize', introWithGridCardsComponent.breakpointChecker);
      introWithGridCardsComponent.breakpointChecker();
    },
    breakpointChecker: () => {
      // if larger viewport and multi-row layout needed
      if (introWithGridCardsComponent.breakpoint.matches === true) {
        return introWithGridCardsComponent.enableSwiper();

      } else if (introWithGridCardsComponent.breakpoint.matches === false) {
        if (introWithGridCardsComponent.swipers.length) {
          introWithGridCardsComponent.swipers.forEach(swiper => {
            swiper.destroy(true, true);
          });
          introWithGridCardsComponent.swipers = [];
        }
      }
    },
    enableSwiper: () => {
      document.querySelectorAll('.intro_with_grid_cards__swiper-container').forEach(swiper => {
        introWithGridCardsComponent.swipers.push(new Swiper(swiper, {
          direction: 'horizontal',
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
          },
          slidesPerView: 1,
          spaceBetween: 24,
          preloadImages: false,
          lazy: true,
          watchSlidesVisibility: true,
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          }
        }));
      });
    }
  }

  introWithGridCardsComponent.init();

  // breakpoint where swiper will be destroyed
  // and switches to a dual-column layout
  const breakpoint = window.matchMedia('(min-width:768px)');

  // keep track of swiper instances to destroy later
  let mySwipers = [];

  const breakpointChecker = function () {
    // if larger viewport and multi-row layout needed
    if (breakpoint.matches === true) {

      // fire small viewport version of swiper
      return enableSwiper();

      // else if a small viewport and single column layout needed
    } else if (breakpoint.matches === false) {

      // clean up old instances and inline styles when available
      if (mySwipers.length) {
        mySwipers.forEach(swiper => {
          swiper.destroy(true, true);
        })
        mySwipers = [];
      }

      // or/and do nothing
      return;

    }

  };

  const enableSwiper = function () {
    document.querySelectorAll('.swiper-container-large').forEach(swiper => {
      mySwipers.push(new Swiper(swiper, {
        direction: 'horizontal',
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
        },
        slidesPerView: 'auto',
        spaceBetween: 24,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      }));
    })
  };

  // keep an eye on viewport size changes
  breakpoint.addListener(breakpointChecker);

  // kickstart
  breakpointChecker();

  /* end REMOVE */

  /* Search load more */
  $('.js-search').each(function () {
    var $this = $(this);
    var ajaxUrl = $this.data('ajax-url');
    var $fetchMoreButton = $this.find('.js-more-search-items');
    var $itemsContainer = $this.find('.search-items');

    $this.on('fetchMore', function () {
      var data = {
        action: 'search_load_more',
        s: $this.data('search-term'),
        offset: $this.find('.search-item, .card').length,
        newsroom: $this.data('newsroom'),
        view_mode: $this.data('view-mode'),
      }

      $.post(ajaxUrl, data, function (response) {
        $itemsContainer.append(response.html);

        if (!response.hasMore) {
          $fetchMoreButton.hide();
        }

        $fetchMoreButton.removeClass('waiting');

      }, 'json');
    });

    $fetchMoreButton.click(function (e) {
      e.preventDefault();
      $this.trigger('fetchMore');
      $fetchMoreButton.addClass('waiting');
    });

  });

  /* Load more speakers */
  var speakers = document.querySelectorAll(".speakers");
  if (speakers.length > 0) {

    speakers.forEach(speakerSection => {

      var items = speakerSection.querySelectorAll(".js-speaker");
      var loadMore = speakerSection.querySelectorAll(".js-more-speakers")[0];

      let maxItems = 8;
      let loadItems = 8;
      let hiddenClass = "hidden";

      items.forEach(function (item, index) {
        if (index > maxItems - 1) {
          item.classList.add(hiddenClass);
        }
      });

      loadMore.addEventListener("click", function () {
        [].forEach.call(document.querySelectorAll("." + hiddenClass), function (item, index) {
          if (index < loadItems) {
            item.classList.remove(hiddenClass);
          }

          if (document.querySelectorAll("." + hiddenClass).length === 0) {
            loadMore.style.display = "none";
          }
        });
      });

    })
  }

});
